import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CountryEffects, countryReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([CountryEffects]), StoreModule.forFeature(`country`, countryReducer)]
})
export class CountryStateModule {}
